import React from "react"

export type AppPreviewData =
  | { state: "on"; token: string; exit: () => Promise<void> }
  | { state: "off" }

export const AppPreviewContext = React.createContext<AppPreviewData>({
  state: "off",
})
